import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralRewardComponent } from './referral-reward.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TickIconModule } from '@app/dynamic-ui/tick-icon/tick-icon.module';



@NgModule({
  declarations: [
    ReferralRewardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TickIconModule
  ]
})
export class ReferralRewardModule { }
